<template>
    <div>
        <popup-modal
            :closeOnClick="!performingRequest"
            position="center"
            @close="$emit('close')"
        >
            <div class="w-960 flex">
                <div class="grid grid-cols-5">
                    <div class="h-full w-480 flex flex-col justify-between col-span-3">
                        <div class="pb-20 space-y-4">
                            <h1 class="text-heading-2 font-semibold mb-9">
                                 <i18n-t keypath="boosters.popup.popup_title" class="inline-flex items-center gap-8">
                                    <template #type>
                                        <span class="font-semibold">{{  booster.title[selectedLocale] }}</span>
                                    </template>
                                    <template #symbol>
                                        <span class="inline-flex items-center font-semibold">
                                            <currency size="24"/>
                                            <span>{{ booster.price }}</span>
                                        </span>
                                    </template>
                                 </i18n-t>
                            </h1>
                            <p class="text-body-sm" v-html="booster.description[selectedLocale]"></p>
                        </div>

                        <div class="space-y-12">
                            <i>{{$t('general.prices_excl_vat', { vat_label: vatLabelForRegion })}}</i>
                             <checkbox v-model="canConfirm">
                                {{ $t('general.payment_confirmation') }}
                            </checkbox>
                            <div>
                                <simple-button
                                    class="w-full"
                                    display="secondary"
                                    :disabled="!canConfirm"
                                    :loading="performingRequest"
                                    look="primary"
                                    @click="confirm"
                                >
                                    {{ $t('boosters.popup.popup_button', {type: booster.title[selectedLocale]}) }}
                            </simple-button>
                            </div>
                        </div>
                    </div>
                    <div class="w-full h-full col-span-2">
                        <img :src="card.image_url" alt="" class="rounded-3xl">
                    </div>
                </div>

            </div>
       </popup-modal>
    </div>

</template>
<script>
import Booster from '../models/Booster';
import Currency from './Currency.vue';
import PopupModal from './ui/PopupModal.vue';
import {mapState, mapActions} from 'pinia';
import {useRepo} from 'pinia-orm';
import {useMainStore} from '../state/store';
import {useAuthenticationStore} from '../state/modules/authentication';
import Checkbox from './forms/Checkbox.vue';
import SvgIcon from './ui/SvgIcon.vue';
import ShareJobCard from "../models/ShareJobCard.js";
import * as booster from "../services/BoosterService";
import {ADD_NOTIFICATION} from "../state/mutation-types";
import SimpleButton from "./ui/SimpleButton.vue";
import Job from "../models/Job";
import RegionLabel from "../mixins/regionLabel";

export default {
    components: {
        SimpleButton,
        SvgIcon,
        PopupModal,
        Currency,
        Checkbox,

    },
    mixins: [RegionLabel],
    props: {
        card: ShareJobCard,
        job: Job,
    },
    data() {
        return {
            canConfirm: false,
            performingRequest: false,
        };
    },
    computed: {
        ...mapState(useMainStore, ['selectedLocale']),
        ...mapState(useAuthenticationStore, ['currentUser']),
        booster() {
            return useRepo(Booster).where('type', this.card.type_ref).first();
        },
    },
    methods: {
        close() {
            this.$emit('close');
        },
        confirm() {
            this.performingRequest = true;

            booster.requestIntegration(this.currentUser.id, {
                data: {
                    job: this.job.id,
                    booster: this.booster,
                },
            }).then(() => {
                this[ADD_NOTIFICATION]({
                    type: 'success',
                    message: this.$t('boosters.request_success', {type: this.booster.title[this.locale]}),
                });
            }).finally(() => {
                this.performingRequest = false
                this.close();
            });
        },
    },
}
</script>
<style></style>
